import Drawable from '../entities/Drawable.js';
import { imageStore } from '../images.js';
import Sprite from './Sprite.js';

export default class PokemonSprite extends Drawable {
    constructor({ pokemon, position = { x: 0, y: 0 } }) {
        super();
        this.pokemon = pokemon;
        this.position = position;
        this.sprites = {};
        this.sprites.pokemonSprite = new Sprite({
            position: this.position,
            image: imageStore.get('img/spritesheets/pokemon_front_master_spritesheet_20_20.png'),
            isFromSpriteSheet: true,
            spriteSheetCols: 20,
            spriteSheetRows: 20,
            spriteIndex: pokemon === null ? 399 : pokemon.id - 1, // Default to last grid slot in sprite sheet (will be blank)
        });
    }

    draw() {
        if (this.pokemon === null) {
            return;
        }
        this.sprites.pokemonSprite.visible = true;
        if (!this.sprites.pokemonSprite) {
            return;
        }
        this.sprites.pokemonSprite.position = this.position;
        this.sprites.pokemonSprite.spriteIndex = this.pokemon.id - 1;
        this.sprites.pokemonSprite.draw();
    }
}
